import { render, staticRenderFns } from "./ViewLeads.vue?vue&type=template&id=596a25c2&"
import script from "./ViewLeads.vue?vue&type=script&lang=js&"
export * from "./ViewLeads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ViewLeads.vue"
export default component.exports